import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Featured Projects`}</h2>
    <ProjectCard title="Dation Dashboard" link="https://www.dation.nl/dashboard-dation/" bg="linear-gradient(to right, #712b8b 0%, #e71e7a 100%)" mdxType="ProjectCard">
  Saas, ERP, Driving School Management Software (React, Firebase, Symfony)
    </ProjectCard>
    <ProjectCard title="Dation Rijbewijs App" link="https://www.dation.nl/rijbewijsapp/" bg="linear-gradient(to right, #712b8b 0%, #e71e7a 100%)" mdxType="ProjectCard">
  Students Mobile App, Connects with Dation Dashboard (React Native, Android, iOS)
    </ProjectCard>
    <ProjectCard title="Dation Onderweg App" link="https://www.dation.nl/dation-onderweg/" bg="linear-gradient(to right, #712b8b 0%, #e71e7a 100%)" mdxType="ProjectCard">
  Admins and Instructors Mobile App, Connects with Dastion Dashboard (React Native, Android, iOS)
    </ProjectCard>
    <ProjectCard title="SBVO Portal and API" link="https://www.dation.nl/het-bedrijvenportaal/" bg="linear-gradient(to right, #712b8b 0%, #e71e7a 100%)" mdxType="ProjectCard">
Complete insight into the training needs of drivers and employees
    </ProjectCard>
    <ProjectCard title="My Portfolio" link="https://moyadaniel.com" bg="linear-gradient(to right, #712b8b 0%, #e71e7a 100%)" mdxType="ProjectCard">
  Html, Sass, Javascript, React, Gatsby, CI/CD.
    </ProjectCard>
    <ProjectCard title="EMURGO Website" link="https://emurgo.io" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  Emurgo website official website. Html, Sass, Javascript, React, Nodejs, CI/CD.
  <strong> <br></br>Project might present differences from the previous versions</strong>
    </ProjectCard>
    <ProjectCard title="React Community Chat" link="https://friendlychat-84bf3.firebaseapp.com/" bg="linear-gradient(to right, #059047 0%, #faea23 100%)" mdxType="ProjectCard">
  Realtime Chat build with Html, css, Javascript, CI/CD. Firebase
  Authentication, Firestore, Cloud Storage, FCM.
    </ProjectCard>
    <ProjectCard title="Appilicous (Demo Site)" link="https://daniel-moya.github.io/Responsive-Website/" bg="linear-gradient(to right, #d087fd 0%, #01fdf2 100%)" mdxType="ProjectCard">
  Responsive website build with Html, css, Javascript.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      